const pricelist = {
  
    "JVS1":40,
    "JVS2":40,
    "JVS3":40,
    "JVS4":40,
    "JVS5":40,
    "JVD1":40,
    "JVD2":40,
    "JVD3":40,
    "JVD4":40,
    "JVD5":40,
    "JVG1":40,
    "JVG2":40,
    "JVG3":40,
    "JVG4":40,
    "JVG5":40,
    "JIS1":40,
    "JIS2":40,
    "JIS3":40,
    "JIS4":40,
    "JIS5":40,
    "JID1":40,
    "JID2":40,
    "JID3":40,
    "JID4":40,
    "JID5":40,
    "JIG1":40,
    "JIG2":40,
    "JIG3":40,
    "JIG4":40,
    "JIG5":40,

    "PCVS1":35,
    "PCVS2":35,
    "PCVS3":35,
    "PCVS4":35,
    "PCIS1":35,
    "PCIS2":35,
    "PCIS3":35,
    "PCIS4":35,
    "PCOS1":35,
    "PCOS2":35,
    "PCVD1":35,
    "PCVD2":35,
    "PCVD3":35,
    "PCVD4":35,
    "PCID1":35,
    "PCID2":35,
    "PCID3":35,
    "PCID4":35,
    "PCOD1":35,
    "PCOD2":35,
    "PCVG1":35,
    "PCVG2":35,
    "PCVG3":35,
    "PCVG4":35,
    "PCIG1":35,
    "PCIG2":35,
    "PCIG3":35,
    "PCIG4":35,
    "PCOG1":35,
    "PCOG2":35,

    "PRVS1":35,
    "PRVS2":35,
    "PRVS3":35,
    "PRVS4":35,
    "PRIS1":35,
    "PRIS2":35,
    "PRIS3":35,
    "PRIS4":35,
    "PROS1":35,
    "PROS2":35,
    "PRVD1":35,
    "PRVD2":35,
    "PRVD3":35,
    "PRVD4":35,
    "PRID1":35,
    "PRID2":35,
    "PRID3":35,
    "PRID4":35,
    "PROD1":35,
    "PROD2":35,
    "PRVG1":35,
    "PRVG2":35,
    "PRVG3":35,
    "PRVG4":35,
    "PRIG1":35,
    "PRIG2":35,
    "PRIG3":35,
    "PRIG4":35,
    "PROG1":35,
    "PROG2":35,

    "PPVS1":35,
    "PPVS2":35,
    "PPVS3":35,
    "PPVS4":35,
    "PPIS1":35,
    "PPIS2":35,
    "PPIS3":35,
    "PPIS4":35,
    "PPOS1":35,
    "PPOS2":35,
    "PPVD1":35,
    "PPVD2":35,
    "PPVD3":35,
    "PPVD4":35,
    "PPID1":35,
    "PPID2":35,
    "PPID3":35,
    "PPID4":35,
    "PPOD1":35,
    "PPOD2":35,
    "PPVG1":35,
    "PPVG2":35,
    "PPVG3":35,
    "PPVG4":35,
    "PPIG1":35,
    "PPIG2":35,
    "PPIG3":35,
    "PPIG4":35,
    "PPOG1":35,
    "PPOG2":35,

    "RVS1":35,
    "RVS2":35,
    "RVS3":35,
    "RVS4":35,
    "RIS1":35,
    "RIS2":35,
    "RIS3":35,
    "RIS4":35,
    "ROS1":35,
    "ROS2":35,
    "RVD1":35,
    "RVD2":35,
    "RVD3":35,
    "RVD4":35,
    "RID1":35,
    "RID2":35,
    "RID3":35,
    "RID4":35,
    "ROD1":35,
    "ROD2":35,
    "RVG1":35,
    "RVG2":35,
    "RVG3":35,
    "RVG4":35,
    "RIG1":35,
    "RIG2":35,
    "RIG3":35,
    "RIG4":35,
    "ROG1":35,
    "ROG2":35,





    "IYAOTESTPAYMENT":0.01,
}

export default pricelist;